import { Routes, Route } from 'react-router-dom'
import MessageView from './components/MessageView'
import SetupNew from './components/SetupNew'
import Dashboard from './components/Dashboard'
import AdminNew from './components/AdminNew'
import Home from './components/Home'
import NotFound from './components/NotFound'
import CookieConsent from './components/CookieConsent'
import Privacy from './components/Privacy'
import EnvironmentBanner from './components/EnvironmentBanner'
import { SiteHeader } from './components/SiteHeader'
import { SiteFooter } from './components/SiteFooter'
import AccountSignup from './components/AccountSignup'
import AccountLogin from './components/AccountLogin'
import MyCodes from './components/MyCodes'
import AccountSettings from './components/AccountSettings'

function App() {
  return (
    <div className="flex flex-col min-h-screen app-bg">
      <EnvironmentBanner />
      <SiteHeader />
      <main className="flex-1">
        <Routes>
          <Route path="/u/:handle" element={<MessageView />} />
          <Route path="/setup" element={<SetupNew />} />
          <Route path="/dashboard/:handle" element={<Dashboard />} />
          <Route path="/admin" element={<AdminNew />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/account/signup" element={<AccountSignup />} />
          <Route path="/account/login" element={<AccountLogin />} />
          <Route path="/my-codes" element={<MyCodes />} />
          <Route path="/account/settings" element={<AccountSettings />} />
          <Route path="/" element={<Home />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <SiteFooter />
      <CookieConsent />
    </div>
  )
}

export default App
